(function() {
    "use strict";

    angular.module("laekkerAI.tablet").component("cleanup", {
        controller: "CleanupController"
    });
})();
